<template>
  <div>
    <AppInfoEmailBrySendDeliveryDetails
      :detalhesEnvioEntrega="detalhesEnvioEntrega"
    />

    <AppInfoEmailBryReadingDetails
      :detalhesLeitura="detalhesLeitura"
    />

  </div>
</template>
<script>
import { Tabs, Tab } from 'uiv'
import AppInfoEmailBrySendDeliveryDetails from './InfoEmailBrySendDeliveryDetails'
import AppInfoEmailBryReadingDetails from './InfoEmailBryReadingDetails'
export default {
  name: 'AppInfoEmailBry',

  props: {
    detalhesEnvioEntrega: {
      type: Object
    },
    detalhesLeitura: {
      type: Object
    }
  },

  computed: {
    hasLeitura () {
      return (this.dataLeitura && this.horaLeitura) || false
    }
  },

  components: {
    Tabs,
    Tab,
    // AppInfoEmailSummary,
    AppInfoEmailBrySendDeliveryDetails,
    AppInfoEmailBryReadingDetails
  }
}
</script>



// WEBPACK FOOTER //
// src/components/provider-bry/InfoEmailBry.vue